// extracted by mini-css-extract-plugin
module.exports = {"search-result-uni-logo":"university-logo_search-result-uni-logo__YOcc5"};